
import React from 'react';
import {
  FormField,
  FormItem,
  FormLabel,
  FormControl,
  FormMessage,
  FormDescription,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { UseFormReturn } from "react-hook-form";
import { OrganizationFormValues } from './types';

interface OrganizationStructureFormSectionProps {
  form: UseFormReturn<OrganizationFormValues>;
}

export function OrganizationStructureFormSection({ form }: OrganizationStructureFormSectionProps) {
  return (
    <div className="space-y-4">
      <FormField
        control={form.control}
        name="org_mapping"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Org Mapping & Stakeholders</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Organization mapping details"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="org_chart_notes"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Org Chart Notes</FormLabel>
            <FormControl>
              <Textarea
                placeholder="Notes on decision-making structure and influence"
                className="resize-none"
                {...field}
              />
            </FormControl>
            <FormDescription>
              Who's who in decision-making (and influence)
            </FormDescription>
            <FormMessage />
          </FormItem>
        )}
      />

      <FormField
        control={form.control}
        name="referral_source"
        render={({ field }) => (
          <FormItem>
            <FormLabel>Referral Source</FormLabel>
            <FormControl>
              <Input placeholder="How this client was referred to us" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
}
